import React, { Component } from 'react'
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import Collapse from "@kunukn/react-collapse";
import classes from './Collapse.module.css';
import image from '../../../Assests/Image/layer_5.png'
import CollapseDiv from './CollapseDiv/CollapseDiv';
class myCollapse extends Component {
  state = {
    open: false
  }
  onClickHandler = () => {
    this.setState({ open: !this.state.open })
  }
  render() {

    let arrow = (<DownOutlined />)
    let headerClass = [classes.header]
    if (this.state.open) {
      headerClass = [classes.header, classes.headerOpen]
      arrow = <UpOutlined />
    }
    console.log(this.props.data)
    return (
      <div className={classes.container}>
        <div className={headerClass.join(" ")}
          onClick={this.onClickHandler}>
          <p className={classes.title}>{this.props.data.title}</p>
          <div className={classes.arrow}>{arrow}</div>
        </div>
        <Collapse isOpen={this.state.open}
          transition={`height 0ms cubic-bezier(.4, 0, .2, 1)`}
          className={classes.collapse}  >
          <div className={classes.desc}>
            <div  className={classes.image}>
              <img style = {{ "border-radius": "20px"}} className = {classes.img}src={this.props.data.image} alt="img"></img>
            </div>
            <div>
              <p className={classes.description}>
                {this.props.data.description}
              </p>
            </div>
          </div>
          <div className={classes.content}>
        <CollapseDiv title = {this.props.data.title } data = {this.props.data.contentList}/>
          </div>
        </Collapse>
      </div>
    )
  }

}

export default myCollapse;